import { ArrowsOutSimple, Command, Crosshair, Keyboard, Tag } from '@phosphor-icons/react';
import w from './Workspace.module.css';
import type { ZoneNumber } from '../model/types';
import { useStore } from '../state/store';
import { Button, Segmented, ZoneSwatch } from '../ui/kit';

export function ViewToolbar() {
  const view = useStore((s) => s.view);
  const help = useStore((s) => s.helpOpen);
  const { setView, requestFocus, setHelp } = useStore.getState();
  const toggleZone = (z: ZoneNumber) => setView({ zones: { ...view.zones, [z]: !view.zones[z] } });
  return (
    <div className={w.viewbar}>
      <div className={w.viewGroup}>
        <Segmented label="View" value={view.mode} onChange={(mode) => setView({ mode })} options={[{ value: 'persp', label: '3D' }, { value: 'plan', label: 'Plan' }, { value: 'elev', label: 'Elevation' }]} />
      </div>
      <div className={w.viewGroup} role="group" aria-label="Zones shown">
        {([0, 1, 2] as const).map((z) => (
          <button key={z} type="button" className={w.zoneToggle} aria-pressed={view.zones[z]} onClick={() => toggleZone(z)} title={`Show Zone ${z} (${z + 1})`}>
            <ZoneSwatch zone={z} /> Zone {z}
          </button>
        ))}
      </div>
      <div className={w.viewGroup}>
        <Button variant="ghost" pressed={view.labels} icon={<Tag size={14} />} onClick={() => setView({ labels: !view.labels })} title="Tags">Tags</Button>
        <Button variant="ghost" pressed={view.datum} icon={<Crosshair size={14} />} onClick={() => setView({ datum: !view.datum })} title="Origin and axes (O)">Origin</Button>
        <Button variant="ghost" icon={<ArrowsOutSimple size={14} />} onClick={requestFocus} title="Frame the selection, or everything (F)">Fit</Button>
        <Button variant="ghost" icon={<Command size={14} />} onClick={() => useStore.getState().setPalette(true)} title="All commands and objects (Ctrl K)">Find</Button>
        <Button variant="ghost" pressed={help} icon={<Keyboard size={14} />} onClick={() => setHelp(!help)} title="Shortcuts and drag gestures (?)">Shortcuts</Button>
      </div>
    </div>
  );
}
